import * as entities from '@owl-nest/entities'
import * as logger from '@owl-nest/logger'
import * as algolia from '@boutique/algolia'
import { matchBrand } from '@boutique/contentful-shopify-matcher'
import * as url from '@boutique/url'

export function hitProduct(
  hit: algolia.product.Product,
  specialCold: {
    brands: {
      name: string
      slug: string
      identifier: string | null
    }[]
    criteria: {
      slug: string
      name: string
      icon: string
    }[]
  },
): entities.product.SearchHitProduct {
  const brand =
    specialCold.brands.find((brand) =>
      /* find matching brand with identifier or name as fallback since identifiers aren't all filled yet */
      matchBrand(hit.brand ?? '', brand),
    )?.name ?? hit.brand

  if (!brand) {
    logger.warn('[algolia] No brand defined for product', { hit })
  }

  const vendor =
    specialCold.brands.find((brand) =>
      /* find matching vendor with identifier or name as fallback since identifiers aren't all filled yet */
      matchBrand(hit.vendor ?? '', brand),
    )?.name ?? hit.vendor

  if (!vendor) {
    logger.warn('[algolia] No vendor defined for product', { hit })
  }

  if (!hit.name && !hit.handle) {
    logger.warn('[algolia] No title defined for product', { hit })
  }

  const criteria =
    (hit.tags
      ?.map((tag) => specialCold.criteria.find((criterion) => criterion.slug === tag))
      .filter((criterion) => criterion)
      .map(
        (criterion) =>
          criterion && {
            icon: criterion.icon,
            name: criterion.name,
          },
      ) as {
      icon: string
      name: string
    }[]) ?? []

  return {
    brand: brand ?? '',
    objectID: hit.objectID!,
    colors: hit.allColors ?? [],
    criteria: criteria,
    title: hit.name ?? hit.handle ?? 'Produit inconnu',
    // FIXME: sensible default for hit.id and hit.handle
    href: url.product({
      id: hit.id ?? 0,
      handle: hit.handle ?? '',
      title: hit.name ?? '',
    }).path,
    priceRange: hit.priceRange ?? [0, 0],
    compareAtPriceRange: getCompareAtPriceRange(hit),
    picture: {
      alt: hit.name || '',
      src: hit.imageUrl1x || '',
      // NOTE: we're forcing 1x version on all DPIs since bigger versions are ... too fat.
      srcSet: `${hit.imageUrl1x} 1x, ${hit.imageUrl1x} 2x, ${hit.imageUrl1x} 3x`,
      origin: hit.imageUrl1x || '',
      width: null,
      height: null,
    },
    vendor: vendor ?? '',
  }
}

function getCompareAtPriceRange(hit: algolia.product.Product): [number, number] | null {
  if (hit.compareAtPriceRange && hit.priceRange) {
    if (hit.priceRange[0] >= hit.compareAtPriceRange[0]) {
      // if (hit.priceRange[0] !== hit.compareAtPriceRange[0]) {
      //     logger.warn(
      //         `[Algolia] - Listing: minimum 'priceRange' is higher than its minimum 'compareAtPriceRange' for hit ${hit.id}`,
      //         {
      //             hit,
      //             values: {
      //                 minPrice: hit.priceRange[0],
      //                 minCompareAtPrice: hit.compareAtPriceRange[0]
      //             }
      //         }
      //     )
      // }
      return null
    }
  }
  return hit.compareAtPriceRange ?? null
}
